enum LeadQuerySortByEnum {
  Name = 'Name',
  Views = 'Views',
  SignedCA = 'SignedCA',
  Created = 'Created',
}

export default LeadQuerySortByEnum;
